import React from 'react'
import { Button as MuiButton, ButtonProps } from '@mui/material'

interface PropsType extends ButtonProps {
	title?: string
	children?: React.ReactNode
	shouldPreventDuplicatedClick?: boolean
	onClick?: (event: React.MouseEvent<HTMLElement>) => void
}

export const Button = (props: PropsType) => {
	const { shouldPreventDuplicatedClick, ...propsElements } = props

	const [isSubmitClicked, setIsSubmitClicked] = React.useState<boolean>(false)

	const shouldPreventDuplicatedClickOption: boolean =
		shouldPreventDuplicatedClick ?? false

	const onClick = (event: React.MouseEvent<HTMLElement>) => {
		if (props.onClick) {
			if (shouldPreventDuplicatedClickOption) {
				if (!isSubmitClicked) {
					props.onClick(event)
					setIsSubmitClicked(true)
					const timeout = setTimeout(() => {
						setIsSubmitClicked(false)
						clearTimeout(timeout)
					}, 1000)
				}
			} else {
				props.onClick(event)
			}
		}
	}
	return (
		<MuiButton {...propsElements} onClick={onClick}>
			{props.children ?? null}
		</MuiButton>
	)
}
